import { render, staticRenderFns } from "./PremiumChangedModal.vue?vue&type=template&id=3c777f12&scoped=true"
import script from "./PremiumChangedModal.vue?vue&type=script&lang=js"
export * from "./PremiumChangedModal.vue?vue&type=script&lang=js"
import style0 from "./PremiumChangedModal.vue?vue&type=style&index=0&id=3c777f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c777f12",
  null
  
)

export default component.exports